import React, { useState, useEffect } from 'react'
import {
  withStyles,
  Typography,
  Grid,
  Paper,
  Box,
  Divider,
} from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import styles from './style'
import { userGetSelfAction } from 'src/reducers/user/action'
import { useDispatch } from 'react-redux'
import Lottie from 'react-lottie'
import animationData from 'src/lotties/AI-ready-v2-mobile_small.json'
import animationDataMobile2 from 'src/lotties/mcg-v4-mobile-desktop.json'
import { get as getCookie, set as setCookie } from 'es-cookie'

import { track } from '@amplitude/analytics-browser'
import { CoreButton } from 'src/components/core'
import URL from 'src/api/url/'
const Options = [
  {
    cardName: 'Create with AI-Assistant',
    icon: '/assets/use-ai-assistant.png',
    text: 'Make AI create a complete course based on your guidance.',
    height: '380px',
    opacity: 1,
  },
  {
    cardName: 'From scratch',
    icon: '/assets/from-scratch.png',
    text: 'Start to build course immediately with your content.',
    badge: 'Optimized for desktop',
    height: '300px',
    opacity: 0.6,
  },
  {
    cardName: 'Select Template',
    icon: '/assets/select-template.png',
    text: 'See use-case ideas and content suggestions from common practices.',
    badge: 'Optimized for desktop',
    height: '300px',
    opacity: 0.6,
  },
]
const MobileUi = props => {
  const { classes, courseData, showCourseReady = false } = props
  let history = useHistory()
  const [collection] = useState(
    window.location.pathname.split('create-course/')[1] || '',
  )
  const dispatch = useDispatch()

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  const mobileLottieOptions = {
    loop: true,
    autoplay: true,
    animationData: animationDataMobile2,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  useEffect(() => {
    if (
      getCookie('redirectUrl') != '' &&
      getCookie('redirectUrl') != null &&
      getCookie('redirectUrl') != undefined
    ) {
      window.location.href = getCookie('redirectUrl')
      setCookie('redirectUrl', '')
    }
    dispatch(userGetSelfAction())
  }, [dispatch])

  return (
    <div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '24px',
          padding: '20px',
        }}
      >
        <Typography fontSize={24} fontWeight={600} textAlign={'center'}>
          Hi {window.CONSTANTS.NAME} 👋
        </Typography>
        <Typography fontSize={16} fontWeight={400} textAlign={'center'}>
          Creating, editing and managing courses are optimized for desktop
          browsers. Please visit your account{' '}
          <span
            style={{
              color: '#015FFB',
            }}
          >
            on desktop
          </span>{' '}
          for the full capability.
        </Typography>
        <Lottie options={mobileLottieOptions} width={300} height={182} />
        <div
          style={{
            borderRadius: '16px',
            padding: '20px',
            gap: '24px',
            backgroundColor: '#FFFFFF',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow:
              '0 0 2px 0 rgba(145, 158, 171, 0.12), 0 12px 24px -4px rgba(145, 158, 171, 0.12);',
          }}
        >
          <Typography
            fontSize={18}
            fontWeight={500}
            textAlign={'center'}
            color={'#015FFB'}
          >
            View your course
          </Typography>

          <Typography fontSize={16} fontWeight={400} textAlign={'center'}>
            Editing is available on desktop, but you can preview your course
            here.
          </Typography>
          <CoreButton
            variant="contained"
            size="large"
            href={courseData ? URL.APP_URL + courseData.code : ''}
            target="_blank"
          >
            Preview Course
          </CoreButton>
        </div>
      </div>
    </div>
  )
}

export default withStyles(styles)(MobileUi)
